import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";
import { CreatePostInput } from "../models/CreatePostInput";

export class PostService {
  static async create(createPostInput: CreatePostInput) {
    return await HttpService.request({
      url: "/posts/create",
      method: "POST",
      data: createPostInput,
      contentType: "json",
    });
  }

  static async getById(userId: string) {
    return await HttpService.request({
      url: `/posts/${userId}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async update(userId: string, updatePostInput: CreatePostInput) {
    return await HttpService.request({
      url: `/posts/${userId}`,
      method: "PUT",
      data: updatePostInput,
      contentType: "json",
    });
  }

  static async delete(userId: string) {
    return await HttpService.request({
      url: `/posts/${userId}`,
      method: "DELETE",
      contentType: "json",
    });
  }

  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/posts/find?${queryParams}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/posts?findOptions=${query}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/posts/search?query=${encodeURIComponent(query)}`,
      method: "GET",
      contentType: "json",
    });
  }
}
